
    import '/home/ec2-user/Youlify-Design/components/switch/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["switch-demo-basic","switch-demo-disabled","switch-demo-text","switch-demo-size","switch-demo-loading","switch-demo-component-token"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/switch/index.en-US.md?type=demo')
};